module.exports = __webpack_public_path__ + "static/media/Bernard.1b294b2c.jpg";